import { PLANTS } from '../data/plants.js';
import { DISASTERS } from '../data/disasters.js';
import { ADVANCED_ONLY_DISASTERS } from '../data/advancedDisasters.js';

let started = false;
let decodeStarted = false;
const preloadedImages = [];

const PLANT_IMAGE_URLS = PLANTS.map((p) => p.imageSrc ?? `/plant-images/${p.id}.webp`);
// Advanced Mode's deck is the Classic cards plus two of its own, so
// both lists are preloaded — otherwise the two Advanced-only cards
// would be the only ones fetched cold at reveal time.
const DISASTER_IMAGE_URLS = [...DISASTERS, ...ADVANCED_ONLY_DISASTERS].map(
  (d) => d.imageSrc ?? `/disaster-images/${d.id}.webp`
);
export const FINAL_SCORE_IMAGE_URLS = [
  '/Excellent.webp',
  '/GoodJob.webp',
  '/Fired.webp'
];
const UI_IMAGE_URLS = [
  '/energy_planner.webp',
  '/COP-Sucess.webp',
  '/Cop_neutral.webp',
  '/COP_collapse.webp',
  ...FINAL_SCORE_IMAGE_URLS
];
const GAME_IMAGE_URLS = [...UI_IMAGE_URLS, ...PLANT_IMAGE_URLS, ...DISASTER_IMAGE_URLS];

function scheduleIdle(callback) {
  if (
    typeof window !== 'undefined' &&
    typeof window.requestIdleCallback === 'function'
  ) {
    return window.requestIdleCallback(callback, { timeout: 2000 });
  }

  return setTimeout(callback, 300);
}

export function decodeImage(src) {
  if (typeof Image === 'undefined') {
    return Promise.resolve();
  }

  const img = new Image();
  img.decoding = 'async';

  if (typeof img.decode === 'function') {
    img.src = src;
    return Promise.resolve(img.decode()).catch(() => undefined);
  }

  return new Promise((resolve) => {
    img.onload = resolve;
    img.onerror = resolve;
    img.src = src;
  });
}

export function decodeImages(urls) {
  return Promise.all(
    urls.map((url) => (
      decodeImage(url).catch(() => undefined)
    ))
  );
}

export function warmDecodeImages(urls, { concurrency = 1 } = {}) {
  const queue = [...urls];
  const workerCount = Math.min(Math.max(1, concurrency), queue.length);

  if (workerCount === 0) {
    return Promise.resolve();
  }

  return Promise.all(
    Array.from({ length: workerCount }, () => (
      new Promise((resolve) => {
        function next() {
          const url = queue.shift();
          if (!url) {
            resolve();
            return;
          }

          decodeImage(url).then(() => scheduleIdle(next));
        }

        scheduleIdle(next);
      })
    ))
  );
}

export function preloadGameImages() {
  if (started) return;
  started = true;

  for (const url of GAME_IMAGE_URLS) {
    const img = new Image();
    img.decoding = 'async';
    img.src = url;
    preloadedImages.push(img);
  }
}

export function warmDecodeGameImages() {
  if (decodeStarted) return;
  decodeStarted = true;

  return warmDecodeImages(GAME_IMAGE_URLS, { concurrency: 1 });
}

export function warmDecodeDisasters() {
  return warmDecodeGameImages();
}
